import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { AutoAwesome as AiIcon } from '@mui/icons-material';
import { NodeViewWrapper, ReactNodeViewProps } from '@tiptap/react';

/**
 * Renders an AI-generated image block within the canvas (spec 044 US4/FR-018), with the
 * same AI badge/border treatment as AiTextBlockNode for FR-024 visual distinction. The
 * `url` is a presigned R2 URL resolved server-side at generation time (AiCanvasActionService).
 */
const ImageBlockNode: React.FC<ReactNodeViewProps> = ({ node }) => {
  const { url, alt, origin } = node.attrs as { url: string; alt: string; origin: 'AI' | 'STUDENT' };
  const isAi = origin === 'AI';

  return (
    <NodeViewWrapper as="div">
      <Box
        sx={{
          my: 1,
          p: 1.5,
          borderRadius: 1,
          bgcolor: isAi ? 'action.hover' : 'transparent',
          borderLeft: '3px solid',
          borderColor: isAi ? 'primary.main' : 'divider',
        }}
        data-origin={origin}
      >
        {isAi && (
          <Chip
            icon={<AiIcon sx={{ fontSize: '14px !important' }} />}
            label="AI"
            size="small"
            color="primary"
            variant="outlined"
            sx={{ height: 20, fontSize: '0.65rem', mb: 0.75 }}
          />
        )}
        {url ? (
          <Box component="img" src={url} alt={alt || 'Generated image'} sx={{ maxWidth: '100%', borderRadius: 1, display: 'block' }} />
        ) : (
          <Typography variant="caption" color="text.secondary">[Image: {alt || 'generating…'}]</Typography>
        )}
        {url && alt && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>{alt}</Typography>
        )}
      </Box>
    </NodeViewWrapper>
  );
};

export default ImageBlockNode;
